import { Component, Inject } from '@angular/core';
import { UserManagementComponent } from '../user-management.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UserDTO } from 'src/app/model/user-dto';
import cloneDeep from 'lodash.clonedeep';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.scss'
})
export class UserDialogComponent {
  public working = false
  public user: UserDTO = {
    id: undefined,
    userName: "",
    name: "",
    surname : "",
    password: "",
    password2: "",
    admin: false
  }

  constructor(
    public dialogRef: MatDialogRef<UserManagementComponent>,
    private readonly toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public receivedUser: UserDTO,
    public userService: UserService,
    public dialog: MatDialog
  ) {
      if(receivedUser?.id != null){
        this.user = cloneDeep(receivedUser)
        this.user.password = ""
        this.user.password2 = ""
      }
  }

  public createUser(): void {
    if(this.user.id == null){
      this.working = true
      this.userService.createUser(this.user)
      .then(response => {
          this.toastr.success('User created succesfully.')
          this.dialogRef.close(true)
      }).catch(_ => {
          this.toastr.error('Error creating the user.')
      }).finally(() => {
        this.working = false
      })
    }
  }

  public updateUser(): void {
    if(this.user.id != null){
      this.working = true
      this.userService.updateUser(this.user)
      .then(response => {
          this.toastr.success('User updated succesfully.')
          this.dialogRef.close(true)
      }).catch(_ => {
          this.toastr.error('Error updating the user.')
      }).finally(() => {
        this.working = false
      })
    }
  }

  public deleteUser(): void {
    if(this.user.id != null){
      this.dialog.open(ConfirmationDialogComponent, {
            data: `Do you want to delete the user ${this.user.userName}?`
          }).afterClosed().subscribe((response) => {
            if(response === true){
              this.working = true
              this.userService.deleteUser(this.user.id!)
              .then(response => {
                  this.toastr.success('User deleted succesfully.')
                  this.dialogRef.close(true)
              }).catch(_ => {
                  this.toastr.error('Error deleting the user.')
              }).finally(() => {
                this.working = false
              })
            }else{
              this.working = false
            }
        }
      )
    }
  }

  public validUserData(): boolean {
    if(this.user.id != null){
      return this.user.userName != null &&
        this.user.name != null &&
        this.user.password2 == this.user.password &&
        this.user.userName.length > 0 &&
        this.user.name.length > 0
    }else{
      return this.user.userName != null &&
        this.user.name != null &&
        this.user.password != null &&
        this.user.password2 == this.user.password &&
        this.user.userName.length > 0 &&
        this.user.name.length > 0 &&
        this.user.password.length > 0
    }
  }
}
